import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface BookingLinkResponse {
  bookingLink: string;
}

interface GetBookingLinkParams {
  classId: string;
}

export const getBookingLinkAPI = async (params: GetBookingLinkParams) => {
  const response = await baseAPI.get<BookingLinkResponse>(
    `/studios/location/booking-link/${params.classId}`,
  );
  return response.data;
};

export const getBookingLinkQueryOptions = (params: GetBookingLinkParams) =>
  queryOptions({
    queryKey: [KEYS.BOOKING_LINK, params.classId],
    queryFn: () => getBookingLinkAPI(params),
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled: !!params.classId,
  });

export const useGetBookingLink = (params: GetBookingLinkParams) => {
  return useQuery(getBookingLinkQueryOptions(params));
};
